import { useAuth } from './AuthContext';
import LoginGate from './LoginGate';

export default function RequireAuth({ children }) {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p className="text-gray-400">Loading…</p>
      </div>
    );
  }

  if (status !== 'authenticated') {
    return <LoginGate />;
  }

  return children;
}
